/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IVisNode {
        id: string;
        label?: string;
        x?: number;
        y?: number;
        color?: string;
        image?: string;
        shape?: string;
        fixed?: boolean;
    }
    
    export interface IVisEdge {
        from: string;
        to: string;
        id: string;
    }
}